const routes = [
    {
        path: '',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                path: '/area_cliente/ordens_servicos',
                component: () => import('../views/Listar')
            }
        ]
    },
    // GCK-21020: o detalhe da ordem de serviço usa o shell do portal, como o
    // do pedido — dentro do children do Interno ele abria com a cara do ERP
    {
        path: '/area_cliente/ordens_servicos/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]

export default routes
